const getParts = s => {
    let slot = s.match(/\{\d+\}/);
    if (!slot) {
        return [s];
    }
    let i = s.indexOf(slot[0]);
    let rest = s.substring(i + slot[0].length);
    return [
        s.substring(0, i),
        {
            slot: true,
            val: parseInt(slot[0].substring(1, slot[0].length - 1), 10)
        }
    ].concat(getParts(rest));
};

export default {
    props: {
        msgKey: { type: String, required: true }
    },
    render(h) {
        const msg = this.$t(this.msgKey);
        const children = getParts(msg).map(p => {
            if (p.slot) {
                return this.$scopedSlots['slot' + p.val]();
            } else {
                return h('span', p);
            }
        });
        return h('span', children);
    }
};
